import { createGoalsStore } from '@edwin/stores'
import { edwinCloudApiClient } from '@services/EdwinCloudApiClient'

export const useGoalsStore = createGoalsStore({
  sessionStorage: window.localStorage,
  apiClient: edwinCloudApiClient,
})

export default useGoalsStore
